
export default class CommonMethods {

    public static validateKeyInputForNumber(evt: any, allowDecimal: boolean, allowMinus: boolean) {
        var e = evt || window.event;
        var key = e.keyCode || e.which;

        if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
            // numbers   
            key >= 48 && key <= 57 ||
            // Numeric keypad
            key >= 96 && key <= 105 ||
            // Backspace and Tab and Enter
            key === 8 || key === 9 || key === 13 ||
            // Home and End
            key === 35 || key === 36 ||
            // left and right arrows
            key === 37 || key === 39 ||
            // Del and Ins
            key === 46 || key === 45 ||
            // minus (numpad) and dash
            (allowMinus && (key === 109 || key === 189)) ||
            // comma, period and . on keypad
            (allowDecimal && (key === 190 || key === 188 || key === 110))
        ) {
            // input is VALID
        } else {
            // input is INVALID
            e.returnValue = false;
            if (e.preventDefault) {
                e.preventDefault();
            }
        }
    }
}
